const AirbnbKey = ({ data, showIndex, handleShow }) => {
  return (
    <>
      {" "}
      <div className={`ar-key-rgt-wrap ${showIndex ? "ar-gp" : ""}`}>
        <div
          className={`ar-key-rgt-top ${showIndex ? "pb" : ""}`}
          onClick={handleShow}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div className="d-flex align-items-center gap-3">
              <span className="ar-key-rgt-num">{data.num}</span>
              <h5 className="ar-ky-tp-title">{data.title}</h5>
            </div>
            <span className="ar-key-rgt-plus ar-mob-plus">
              <i className="fa-solid fa-plus"></i>
            </span>
          </div>
          <p className={`ar-ky-bt-content ${showIndex ? "d-block" : "d-none"}`}>
            {data.description}
          </p>
        </div>

        <div className={`ar-key-rgt-bottom ${showIndex ? "show" : ""}`}>
          <span
            onClick={handleShow}
            className={`ar-key-rgt-plus ${
              showIndex ? "d-none" : "d-block"
            } ar-ky-mob-none`}
          >
            <i className="fa-solid fa-plus"></i>
          </span>
          <img
            src={data.img}
            alt=""
            className={`${showIndex ? "d-block" : "d-none"} ar-mob-center`}
          />
        </div>
      </div>
    </>
  );
};

export default AirbnbKey;
